module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Histórico do paciente " + _vm._s(_vm.historico.data[0] ? _vm.historico.data[0].nm_paciente : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.historico.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacaoAntiga")(item.st_solicitacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_unidade_realizadora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.dt_realizacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_profissional_realizador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_procedimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.dt_solicitacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_unidade_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_profissional_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_profissional_marcador))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\tMostrando " + _vm._s(this.historico.from) + " até " + _vm._s(this.historico.to) + " de " + _vm._s(this.historico.total) + " registros encontrados.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historico
    },
    on: {
      "pagination-change-page": _vm.getHistorico
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(this.hasPermission('paciente-integracao.write')) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disableBtnImportar
    },
    on: {
      "click": function($event) {
        _vm.showModalImportarHistorico = true
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-arrow-down"
  }), _vm._v(" Importar histórico")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "a",
      "to": '/integracao/pacientes'
    }
  }, [_c('span', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])], 1)])])])])]), _vm._v(" "), _c('modal-importar-historico', {
    attrs: {
      "cdPessoa": _vm.$route.params.cdPessoa,
      "show": _vm.showModalImportarHistorico
    },
    on: {
      "close": function($event) {
        _vm.showModalImportarHistorico = false
      },
      "historicoImportado": function($event) {
        _vm.historicoImportado()
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-51a9c4ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/integracao/pacientes/historico.vue
// module id = 847
// module chunks = 0